// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as DevelopersRouteImport } from './routes/developers'
import { Route as AiTeammatesRouteImport } from './routes/ai-teammates'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as DocsIndexRouteImport } from './routes/docs.index'
import { Route as DocsWebhooksGuideRouteImport } from './routes/docs.webhooks-guide'
import { Route as DocsWebhooksRouteImport } from './routes/docs.webhooks'
import { Route as DocsWebhookTriggersRouteImport } from './routes/docs.webhook-triggers'
import { Route as DocsUsersRouteImport } from './routes/docs.users'
import { Route as DocsTeammatesRouteImport } from './routes/docs.teammates'
import { Route as DocsTasksRouteImport } from './routes/docs.tasks'
import { Route as DocsStreamingRouteImport } from './routes/docs.streaming'
import { Route as DocsSkillsRouteImport } from './routes/docs.skills'
import { Route as DocsSchedulingRouteImport } from './routes/docs.scheduling'
import { Route as DocsRunsRouteImport } from './routes/docs.runs'
import { Route as DocsQuickstartRouteImport } from './routes/docs.quickstart'
import { Route as DocsPermissionsRouteImport } from './routes/docs.permissions'
import { Route as DocsMemoriesRouteImport } from './routes/docs.memories'
import { Route as DocsIntroductionRouteImport } from './routes/docs.introduction'
import { Route as DocsIntegrationsRouteImport } from './routes/docs.integrations'
import { Route as DocsFilesRouteImport } from './routes/docs.files'
import { Route as DocsEmailInboxRouteImport } from './routes/docs.email-inbox'
import { Route as DocsCoreConceptsRouteImport } from './routes/docs.core-concepts'
import { Route as DocsCliRouteImport } from './routes/docs.cli'
import { Route as DocsApiReferenceRouteImport } from './routes/docs.api-reference'
import { Route as DocsApiPaginationRouteImport } from './routes/docs.api-pagination'
import { Route as DocsApiIntroductionRouteImport } from './routes/docs.api-introduction'
import { Route as DocsApiErrorsRouteImport } from './routes/docs.api-errors'
import { Route as AiTeammatesMarketingRouteImport } from './routes/ai-teammates.marketing'
import { Route as DashboardIntegrationsRouteImport } from './routes/_dashboard.integrations'
import { Route as DashboardDeveloperRouteImport } from './routes/_dashboard.developer'
import { Route as DashboardBillingRouteImport } from './routes/_dashboard.billing'
import { Route as DashboardAutomationsRouteImport } from './routes/_dashboard.automations'
import { Route as DashboardAccountRouteImport } from './routes/_dashboard.account'
import { Route as IntegrationsGoogleSearchConsoleCallbackRouteImport } from './routes/integrations/google-search-console/callback'
import { Route as IntegrationsGoogleAdsCallbackRouteImport } from './routes/integrations/google-ads/callback'
import { Route as AuthGoogleCallbackRouteImport } from './routes/auth/google/callback'
import { Route as AiTeammatesMarketingSeoRouteImport } from './routes/ai-teammates.marketing.seo'
import { Route as AiTeammatesMarketingGoogleAdsRouteImport } from './routes/ai-teammates.marketing.google-ads'
import { Route as DashboardTeammatesIdRouteImport } from './routes/_dashboard.teammates.$id'
import { Route as DashboardRunsRunIdRouteImport } from './routes/_dashboard.runs.$runId'
import { Route as DashboardDeveloperIndexRouteImport } from './routes/_dashboard.developer.index'
import { Route as DashboardDeveloperTeammatesRouteImport } from './routes/_dashboard.developer.teammates'
import { Route as DashboardDeveloperTasksRouteImport } from './routes/_dashboard.developer.tasks'
import { Route as DashboardDeveloperRunsRouteImport } from './routes/_dashboard.developer.runs'
import { Route as DashboardDeveloperLogsRouteImport } from './routes/_dashboard.developer.logs'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DocsRoute = DocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const DevelopersRoute = DevelopersRouteImport.update({
            id: '/developers',path: '/developers',getParentRoute: () => rootRouteImport
          })
const AiTeammatesRoute = AiTeammatesRouteImport.update({
            id: '/ai-teammates',path: '/ai-teammates',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/_dashboard',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ShareTokenRoute = ShareTokenRouteImport.update({
            id: '/share/$token',path: '/share/$token',getParentRoute: () => rootRouteImport
          })
const DocsIndexRoute = DocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DocsRoute
          })
const DocsWebhooksGuideRoute = DocsWebhooksGuideRouteImport.update({
            id: '/webhooks-guide',path: '/webhooks-guide',getParentRoute: () => DocsRoute
          })
const DocsWebhooksRoute = DocsWebhooksRouteImport.update({
            id: '/webhooks',path: '/webhooks',getParentRoute: () => DocsRoute
          })
const DocsWebhookTriggersRoute = DocsWebhookTriggersRouteImport.update({
            id: '/webhook-triggers',path: '/webhook-triggers',getParentRoute: () => DocsRoute
          })
const DocsUsersRoute = DocsUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => DocsRoute
          })
const DocsTeammatesRoute = DocsTeammatesRouteImport.update({
            id: '/teammates',path: '/teammates',getParentRoute: () => DocsRoute
          })
const DocsTasksRoute = DocsTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => DocsRoute
          })
const DocsStreamingRoute = DocsStreamingRouteImport.update({
            id: '/streaming',path: '/streaming',getParentRoute: () => DocsRoute
          })
const DocsSkillsRoute = DocsSkillsRouteImport.update({
            id: '/skills',path: '/skills',getParentRoute: () => DocsRoute
          })
const DocsSchedulingRoute = DocsSchedulingRouteImport.update({
            id: '/scheduling',path: '/scheduling',getParentRoute: () => DocsRoute
          })
const DocsRunsRoute = DocsRunsRouteImport.update({
            id: '/runs',path: '/runs',getParentRoute: () => DocsRoute
          })
const DocsQuickstartRoute = DocsQuickstartRouteImport.update({
            id: '/quickstart',path: '/quickstart',getParentRoute: () => DocsRoute
          })
const DocsPermissionsRoute = DocsPermissionsRouteImport.update({
            id: '/permissions',path: '/permissions',getParentRoute: () => DocsRoute
          })
const DocsMemoriesRoute = DocsMemoriesRouteImport.update({
            id: '/memories',path: '/memories',getParentRoute: () => DocsRoute
          })
const DocsIntroductionRoute = DocsIntroductionRouteImport.update({
            id: '/introduction',path: '/introduction',getParentRoute: () => DocsRoute
          })
const DocsIntegrationsRoute = DocsIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => DocsRoute
          })
const DocsFilesRoute = DocsFilesRouteImport.update({
            id: '/files',path: '/files',getParentRoute: () => DocsRoute
          })
const DocsEmailInboxRoute = DocsEmailInboxRouteImport.update({
            id: '/email-inbox',path: '/email-inbox',getParentRoute: () => DocsRoute
          })
const DocsCoreConceptsRoute = DocsCoreConceptsRouteImport.update({
            id: '/core-concepts',path: '/core-concepts',getParentRoute: () => DocsRoute
          })
const DocsCliRoute = DocsCliRouteImport.update({
            id: '/cli',path: '/cli',getParentRoute: () => DocsRoute
          })
const DocsApiReferenceRoute = DocsApiReferenceRouteImport.update({
            id: '/api-reference',path: '/api-reference',getParentRoute: () => DocsRoute
          })
const DocsApiPaginationRoute = DocsApiPaginationRouteImport.update({
            id: '/api-pagination',path: '/api-pagination',getParentRoute: () => DocsRoute
          })
const DocsApiIntroductionRoute = DocsApiIntroductionRouteImport.update({
            id: '/api-introduction',path: '/api-introduction',getParentRoute: () => DocsRoute
          })
const DocsApiErrorsRoute = DocsApiErrorsRouteImport.update({
            id: '/api-errors',path: '/api-errors',getParentRoute: () => DocsRoute
          })
const AiTeammatesMarketingRoute = AiTeammatesMarketingRouteImport.update({
            id: '/marketing',path: '/marketing',getParentRoute: () => AiTeammatesRoute
          })
const DashboardIntegrationsRoute = DashboardIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => DashboardRoute
          })
const DashboardDeveloperRoute = DashboardDeveloperRouteImport.update({
            id: '/developer',path: '/developer',getParentRoute: () => DashboardRoute
          })
const DashboardBillingRoute = DashboardBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => DashboardRoute
          })
const DashboardAutomationsRoute = DashboardAutomationsRouteImport.update({
            id: '/automations',path: '/automations',getParentRoute: () => DashboardRoute
          })
const DashboardAccountRoute = DashboardAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => DashboardRoute
          })
const IntegrationsGoogleSearchConsoleCallbackRoute = IntegrationsGoogleSearchConsoleCallbackRouteImport.update({
            id: '/integrations/google-search-console/callback',path: '/integrations/google-search-console/callback',getParentRoute: () => rootRouteImport
          })
const IntegrationsGoogleAdsCallbackRoute = IntegrationsGoogleAdsCallbackRouteImport.update({
            id: '/integrations/google-ads/callback',path: '/integrations/google-ads/callback',getParentRoute: () => rootRouteImport
          })
const AuthGoogleCallbackRoute = AuthGoogleCallbackRouteImport.update({
            id: '/auth/google/callback',path: '/auth/google/callback',getParentRoute: () => rootRouteImport
          })
const AiTeammatesMarketingSeoRoute = AiTeammatesMarketingSeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => AiTeammatesMarketingRoute
          })
const AiTeammatesMarketingGoogleAdsRoute = AiTeammatesMarketingGoogleAdsRouteImport.update({
            id: '/google-ads',path: '/google-ads',getParentRoute: () => AiTeammatesMarketingRoute
          })
const DashboardTeammatesIdRoute = DashboardTeammatesIdRouteImport.update({
            id: '/teammates/$id',path: '/teammates/$id',getParentRoute: () => DashboardRoute
          })
const DashboardRunsRunIdRoute = DashboardRunsRunIdRouteImport.update({
            id: '/runs/$runId',path: '/runs/$runId',getParentRoute: () => DashboardRoute
          })
const DashboardDeveloperIndexRoute = DashboardDeveloperIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDeveloperRoute
          })
const DashboardDeveloperTeammatesRoute = DashboardDeveloperTeammatesRouteImport.update({
            id: '/teammates',path: '/teammates',getParentRoute: () => DashboardDeveloperRoute
          })
const DashboardDeveloperTasksRoute = DashboardDeveloperTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => DashboardDeveloperRoute
          })
const DashboardDeveloperRunsRoute = DashboardDeveloperRunsRouteImport.update({
            id: '/runs',path: '/runs',getParentRoute: () => DashboardDeveloperRoute
          })
const DashboardDeveloperLogsRoute = DashboardDeveloperLogsRouteImport.update({
            id: '/logs',path: '/logs',getParentRoute: () => DashboardDeveloperRoute
          })





const DashboardDeveloperRouteChildren = {
  DashboardDeveloperLogsRoute: DashboardDeveloperLogsRoute,DashboardDeveloperRunsRoute: DashboardDeveloperRunsRoute,DashboardDeveloperTasksRoute: DashboardDeveloperTasksRoute,DashboardDeveloperTeammatesRoute: DashboardDeveloperTeammatesRoute,DashboardDeveloperIndexRoute: DashboardDeveloperIndexRoute
}

const DashboardDeveloperRouteWithChildren = DashboardDeveloperRoute._addFileChildren(DashboardDeveloperRouteChildren)



const DashboardRouteChildren = {
  DashboardAccountRoute: DashboardAccountRoute,DashboardAutomationsRoute: DashboardAutomationsRoute,DashboardBillingRoute: DashboardBillingRoute,DashboardDeveloperRoute: DashboardDeveloperRouteWithChildren,DashboardIntegrationsRoute: DashboardIntegrationsRoute,DashboardRunsRunIdRoute: DashboardRunsRunIdRoute,DashboardTeammatesIdRoute: DashboardTeammatesIdRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)




const AiTeammatesMarketingRouteChildren = {
  AiTeammatesMarketingGoogleAdsRoute: AiTeammatesMarketingGoogleAdsRoute,AiTeammatesMarketingSeoRoute: AiTeammatesMarketingSeoRoute
}

const AiTeammatesMarketingRouteWithChildren = AiTeammatesMarketingRoute._addFileChildren(AiTeammatesMarketingRouteChildren)



const AiTeammatesRouteChildren = {
  AiTeammatesMarketingRoute: AiTeammatesMarketingRouteWithChildren
}

const AiTeammatesRouteWithChildren = AiTeammatesRoute._addFileChildren(AiTeammatesRouteChildren)




const DocsRouteChildren = {
  DocsApiErrorsRoute: DocsApiErrorsRoute,DocsApiIntroductionRoute: DocsApiIntroductionRoute,DocsApiPaginationRoute: DocsApiPaginationRoute,DocsApiReferenceRoute: DocsApiReferenceRoute,DocsCliRoute: DocsCliRoute,DocsCoreConceptsRoute: DocsCoreConceptsRoute,DocsEmailInboxRoute: DocsEmailInboxRoute,DocsFilesRoute: DocsFilesRoute,DocsIntegrationsRoute: DocsIntegrationsRoute,DocsIntroductionRoute: DocsIntroductionRoute,DocsMemoriesRoute: DocsMemoriesRoute,DocsPermissionsRoute: DocsPermissionsRoute,DocsQuickstartRoute: DocsQuickstartRoute,DocsRunsRoute: DocsRunsRoute,DocsSchedulingRoute: DocsSchedulingRoute,DocsSkillsRoute: DocsSkillsRoute,DocsStreamingRoute: DocsStreamingRoute,DocsTasksRoute: DocsTasksRoute,DocsTeammatesRoute: DocsTeammatesRoute,DocsUsersRoute: DocsUsersRoute,DocsWebhookTriggersRoute: DocsWebhookTriggersRoute,DocsWebhooksRoute: DocsWebhooksRoute,DocsWebhooksGuideRoute: DocsWebhooksGuideRoute,DocsIndexRoute: DocsIndexRoute
}

const DocsRouteWithChildren = DocsRoute._addFileChildren(DocsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,DashboardRoute: DashboardRouteWithChildren,AiTeammatesRoute: AiTeammatesRouteWithChildren,DevelopersRoute: DevelopersRoute,DocsRoute: DocsRouteWithChildren,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,PricingRoute: PricingRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ResetPasswordRoute: ResetPasswordRoute,SignupRoute: SignupRoute,TermsRoute: TermsRoute,VerifyEmailRoute: VerifyEmailRoute,ShareTokenRoute: ShareTokenRoute,AuthGoogleCallbackRoute: AuthGoogleCallbackRoute,IntegrationsGoogleAdsCallbackRoute: IntegrationsGoogleAdsCallbackRoute,IntegrationsGoogleSearchConsoleCallbackRoute: IntegrationsGoogleSearchConsoleCallbackRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)